import React, { useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";

import { FaTrashAlt, FaPencilAlt } from "react-icons/fa";

import api from "../../../apis/selectree_api";
import { getAuthHeader } from "../../../utilities/header";

import FormFieldPlainText from "../../FormField/FormFieldPlainText";
import FormFieldText from "../../FormField/FormFieldText";
import TextInput from "../../FormField/TextInput";
import MenuInput from "../../FormField/MenuInput";
import { toast } from "react-toastify";
import {
  deleteCommonThunk,
  updateCommonThunk,
  getCommonDataThunk,
} from "../../../actions/common";

function CommonForm(props) {
  const tree_id = useSelector(state => state.treeDetail.tree_id);

  const { common, sequenceOptions } = props;
  const [edit, setEdit] = useState(false);
  const [state, setState] = useState(common);
  const dispatch = useDispatch();

  function updateCommon() {
    dispatch(updateCommonThunk(state)).then(res => {
      if (res.status === 200) {
        dispatch(getCommonDataThunk(tree_id));
        toast.success("Common Updated");
        setEdit(false);
      } else {
        toast.error("Failed to Update Common");
      }
    });
  }

  function deleteCommon() {
    dispatch(deleteCommonThunk(common.common_id)).then(res => {
      if (res.status === 204) {
        dispatch(getCommonDataThunk(tree_id));
        toast.success("Common Deleted");
      } else {
        toast.error("Failed to Delete Common");
      }
    });
  }

  function updateState(name, v) {
    console.log(`${name} updated to ${v}`);
    setState(state => ({ ...state, [name]: v }));
  }

  if (edit) {
    return (
      <div>
        <Row>
          <Col lg={6}>
            <TextInput
              label="Common Name"
              name="common"
              defaultValue={common.common}
              bubble_on_change={false}
              onChange={updateState}
            />
          </Col>

          <Col lg={12}>
            <span
              onClick={() => setEdit(false)}
              className="form-button-secondary"
            >
              {" "}
              Cancel{" "}
            </span>
            &nbsp;&nbsp;&nbsp;
            <span onClick={updateCommon} className="form-button-primary">
              {" "}
              Save{" "}
            </span>
          </Col>
        </Row>
        <hr />
      </div>
    );
  }

  return (
    <div>
      <div style={{ paddingLeft: "1rem" }}>
        <li>
          {common.common}
          <span onClick={() => setEdit(true)} className="taxon-edit-button">
            <FaPencilAlt />
          </span>
          {common.sequence !== 1 ? (
            <span onClick={deleteCommon} className="taxon-edit-button">
              <FaTrashAlt />
            </span>
          ) : (
            ""
          )}
        </li>
      </div>
      <hr />
    </div>
  );
}

export default CommonForm;
